
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import enviromment from '../../environment';

import './styles.scss';

export default function BreadCrumb(props) {
    const navigate = useNavigate();

    const breads = props.breads.map((item, index) =>
        <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`} aria-current="page" >
            {item.active ? <span >{item.name}</span> : <NavLink to={item.url}>{item.name}</NavLink>}
        </li>
    );
    return (
        <nav className="breadcrumb-nav" aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li>
                    <button className="uninter-btn-voltar" style={{ float: 'left', marginRight: 15 }} onClick={() => { navigate(-1) }}>
                        Voltar
                    </button>
                </li>
                <li>
                    <h3>
                        {enviromment.nome}
                    </h3>
                </li>
                <li className="breadcrumb-item">
                    <NavLink to="/">
                        <i className="fas fa-home mr-2"></i>
                        Início
                    </NavLink>
                </li>
                {breads}
            </ol>
        </nav>
    );
}

BreadCrumb.defaultProps = {
    breads: [],
};